import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ErrorService } from '@cosmos/angular/utils';
import { DailyUsageAggregate } from '@cosmos/shared';
import { catchError, map, Observable } from 'rxjs';
import { environment } from '../../../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MeteringApiService {

  constructor(
    private http: HttpClient,
    private errorService: ErrorService,
  ) {}

  getProjectUsage(projectId: string, start: string, end: string): Observable<HttpResponse<any>> {
    return this.http
      .get(`${environment.API_URL}/metering/usage?projectId=${projectId}&start=${start}&end=${end}`, { observe: 'response' })
      .pipe(
        map(r => r),
        catchError(e => { this.errorService.handleError(e); throw e; })
      );
  }

  getDistributorUsage(companyId: string, start: string, end: string): Observable<HttpResponse<any>> {
    return this.http
      .get(`${environment.API_URL}/metering/distributor-usage?companyId=${companyId}&start=${start}&end=${end}`, { observe: 'response' })
      .pipe(
        map(r => r),
        catchError(e => { this.errorService.handleError(e); throw e; })
      );
  }

  getDailyAggregates(projectIds: string | string[] | null, start: string, end: string): Observable<HttpResponse<DailyUsageAggregate[]>> {
    let qs = `start=${start}&end=${end}`;
    if (projectIds) {
      const ids = Array.isArray(projectIds) ? projectIds : [projectIds];
      qs += ids.map(id => `&projectId=${encodeURIComponent(id)}`).join('');
    }
    return this.http
      .get<DailyUsageAggregate[]>(`${environment.API_URL}/metering/daily-aggregates?${qs}`, { observe: 'response' })
      .pipe(
        map(r => r),
        catchError(e => { this.errorService.handleError(e); throw e; })
      );
  }

  updateDailyAggregate(id: string, body: { count?: number; dailyRate?: number; editReason: string }): Observable<HttpResponse<DailyUsageAggregate>> {
    return this.http
      .patch<DailyUsageAggregate>(`${environment.API_URL}/metering/daily-aggregates/${id}`, body, { observe: 'response' })
      .pipe(
        map(r => r),
        catchError(e => { this.errorService.handleError(e); throw e; })
      );
  }
}
